import { CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { MyMVariantButton } from '../../ui-elements/MyMButton';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import ServiceLv1MetadataCard from './ServiceLv1MetadataCard';

const ResponsiveBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const LeftBox = styled(Box)(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const RightBox = styled(Box)(({ theme }) => ({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    alignItems: 'flex-start', // ここを変更
  },
}));


export const ServiceLv1ServiceTechnicalCard =
  ({ navigateServiceLv2, controlSettings, technicalDocumentGroup, productTypeList }) => {

    const [selectProductType, setProductTypeValue] = useState('');
    const [selectModel, setModelValue] = useState('');
    const [modelConditionList, setModelConditionList] = useState([]);

    const lblMessage = controlSettings.LabelList[`lblTechnicalDocumentDescription`]
    const btnGo = controlSettings.LabelList[`btnGo`]
    const lblProductType = controlSettings.LabelList[`lblProductType`]
    const lblModel = controlSettings.LabelList[`lblModel`]

    /**
     * Product Typeリスト押下時処理
     * @param {Event} e イベント引数
     * @param {any} value 選択アイテム
     */
    const changeProductType = (e, value) => {
      setModelConditionList(productTypeList
        .filter((model) => model.ParentId === value)
        .flatMap((mapModel) => productTypeList.filter((model) => model.ParentId === mapModel.Id)));

      // Product Typeの選択アイテムを設定
      setProductTypeValue(value)
      // Modelの選択アイテムをクリアする
      setModelValue('')
    }

    /**
     * Modelリスト押下時処理
     * @param {Event} e イベント引数
     * @param {any} value 選択アイテム
     */
    const selectModelList = (value) => {
      // Modelの選択アイテムを設定
      setModelValue(value)
    }

    const MyMProductTypeButton = styled(MyMVariantButton)(() => (
      {
        border: '3px solid #FF9900',
        borderRadius: '5px',
        fontSize: "1rem",
        fontWeight: "bold",
        width: '150px',
        color: '#ffffff',
        backgroundColor: '#FF9900',
        ':hover': {
          backgroundColor: '#d88508',
        }
      }))

    const ServiceLv1DropDownList = styled(MyMDropDownList)(() => (
      {
        borderRadius: '5px',
        width: '250px',
        color: '#ffffff',
        backgroundColor: '#ff6600',
        ':hover': {
          backgroundColor: '#d88508',
        },
        'fieldset.MuiOutlinedInput-notchedOutline': {
          top: '-7px'
        }
      }))

    return (
      <ServiceLv1MetadataCard>
        <CardContent className='py-1'>
          {lblMessage && <MyMLabel className='fw-bold'>{lblMessage}</MyMLabel>}
          <ResponsiveBox>
            <LeftBox>
              <List sx={{ '> li:before': { content: '"- "', paddingLeft: '2px', paddingRight: '2px', marginTop: '-4px' } }}>
                {technicalDocumentGroup.DocumentItemNameList.map((documentItemName, index) => (
                  <ListItem disablePadding className='pb-2' key={index} >
                    <MyMLabel className='text-start'>{documentItemName}</MyMLabel>
                  </ListItem>
                ))}
              </List>
            </LeftBox>
            <RightBox>
              <Box sx={{ marginBottom: '5%', width: '250px' }}>
                <ServiceLv1DropDownList
                  needsBlank={true}
                  blankValue={lblProductType}
                  onChange={(e) => { changeProductType(e, e.target.value) }}
                  value={selectProductType}
                  className='mt-0'
                  options={productTypeList.filter((model) => model.ParentId === null).map((productTypeMeta) => {
                    return {
                      value: productTypeMeta.Id,
                      text: productTypeMeta.Name,
                    }
                  })}
                  displayEmpty
                />
              </Box>

              <Box sx={{ marginBottom: '5%', width: '250px' }}>
                {selectProductType &&
                  <ServiceLv1DropDownList
                    needsBlank={true}
                    blankValue={lblModel}
                    onChange={(e) => { selectModelList(e.target.value) }}
                    value={selectModel}
                    className='mt-0'
                    options={modelConditionList.map((model) => {
                      return {
                        value: model.Id,
                        text: model.Name,
                      }
                    })}
                    displayEmpty
                  />}
              </Box>

              <Box sx={{ width: '150px' }}>
                {selectModel &&
                  <MyMProductTypeButton
                    variant="contained"
                    onClick={() => navigateServiceLv2(selectModel)}>{btnGo}
                  </MyMProductTypeButton>}
              </Box>
            </RightBox>
          </ResponsiveBox>
        </CardContent>
      </ServiceLv1MetadataCard>
    )
  }

export default ServiceLv1ServiceTechnicalCard;
